module.exports = __webpack_public_path__ + "img/nachhilfe-md.a611c823.webp";